import { Breakpoint } from '@mui/material';

export const NAVBAR_WIDTH = 288;

export const NAVBAR_MOBILE_RESOLUTION_BREAKPOINT: Breakpoint = 'md';

export const NAVBAR_LIST_ITEM_ACTIVE_OPACITY = 0.12;
export const NAVBAR_LIST_ITEM_ACTIVE_OPACITY_HOVER = 0.05;
export const NAVBAR_LIST_ITEM_ICON_SIZE = 22;
